import { keyframes } from "@emotion/react"
import styled from "@emotion/styled"

const animation2 = keyframes`
    0%{
        transform: scale(1);
    }
    50%{
        transform: scale(1.2);
    }
    100%{
        transform: scale(1);
    }
`
const ContainerEventoIcono= styled.div`
 width: 100%;
 height: 100%;

 
 position: absolute;
   animation:  ${animation2} 2s linear infinite;
    
    z-index: -1;

`
export default ContainerEventoIcono